import { action, observable } from 'mobx'

export class ImportLibraryStore {
  @observable libraryData = null
  @observable errorDetail = null

  @action setLibraryData = (data) => {
    this.libraryData = data
  }

  @action setErrorDetail = (data) => {
    this.errorDetail = data
  }
}
